<template>
  <div>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card border-variant="primary" id="_share">
          <div slot="header" v-if="is_show">
            <strong>Group Invoice Info</strong>
            <b-button size="sm" class="float-right" variant="success" @click="share"> Export </b-button>
          </div>
          <div>
            <div id="header" style="height: 150px;margin: 5px;" v-if="is_show">
              <img v-if="model.partner && model.partner.logo" :src="model.partner.logo" alt="partner logo" width="200">
              <br>
              #1402, 234, Beotkkot-ro, Geumcheon-gu, Seoul, 08513, Republic of Korea
              <br>
              gpartners@f1security.co.kr
              <span class="float-right">{{ model.description }}</span>
            </div>
            <div id="body">
              <center style="border-bottom: blue solid 2px; margin: 10px auto; width: 550px; padding-bottom: 20px;">
                <p style="font-weight: bold; margin: 0; font-size: 24px;">
                  UWSS(<span style="font-weight:500;">Unified Web Security Service</span>) INVOICE
                </p>
                <span>Email or talk to our partner about UWSS account or bill</span>
              </center>

              <div style="min-height: 300px; margin-top:50px;">
                <div style="text-align: left; width: 40%; margin-left: 30px; float: left;">
                  <h2 style="border-bottom: skyblue solid 1px;">User Summary</h2>
                  <div style="border-bottom: blue solid 2px;">
                    <p style="padding-left: 20px; border-bottom: skyblue solid 1px; padding-bottom: 15px;">
                      Account : <br>
                      {{ model.group.groupname }}
                    </p>
                    <p style="padding-left: 20px">
                      Bill to Group(Customer) : <br>
                      {{ model.group.groupname }}
                    </p>
                    <p style="padding-left: 20px;">
                      Bill to Address : <br>
                      {{ model.group.address }}
                    </p>
                  </div>
                </div>

                <div style="text-align: left; width: 45%; margin-right: 60px; float: right;">
                  <h2 style="border-bottom: skyblue solid 1px;">Invoice Summary</h2>
                  <div style="border-bottom: blue solid 2px;">
                    <p style="padding-left: 20px; border-bottom: skyblue solid 1px; padding-bottom: 10px;">
                      Invoice Number: <span style="float: right;"> {{ model.invoice_id }} </span>
                      <br>
                      Invoice Date: <span style="float: right;"> {{ model.created_at | sdate }} </span>
                    </p>
                    <p>
                      Total Amount: <span style="float: right;"> {{ model.currency }}  {{ (model.total_price + model.total_paid) | dollar }} </span>
                    </p>
                  </div>
                </div>
              </div>

              <div style="margin: 0 auto; text-align: left; padding-left: 29px;">
                <div>
                  <h2 style="padding-bottom: 0px; width: 80%;">
                    Billing period: {{ model.start_at | date }}  - {{ model.end_at | date }}
                  </h2>
                  <span style="padding-left: 15px;">
                    Greetings from F1Security, we're writing to provide you with an electronic invoice for your use of UWSS
                  </span>
                  <br>
                  <span style="padding-left: 15px;">
                    Additional information about this invoice, please access the console site and check the billing page.
                  </span>
                </div>
                <br>
                <table style="width: 100%; text-align: left; border-collapse: collapse; border-spacing: 0; margin: 0 auto;">
                  <tr style="background-color: gainsboro;">
                    <th style="padding: 5px;" colspan="3">Detail For Bill</th>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">UWSS Service Type</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.service_name }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Quantity & Amount Used</td>
                    <td style="border-top: black solid 1px;">{{ model.service_unit }}</td>
                    <td style="border-top: black solid 1px;">{{ model.base_price }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WEBCastle (Web Application Firewall)</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.wc_usage }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WSFinder (Anti-WebShell)</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.wsf_usage }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WMDS (Web Malware Scanner)</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.wmds_usage }} </td>
                  </tr>
                  <tr>
                    <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WFDetector (Web Forgery Detection)</td>
                    <td colspan="2" style="border-top: black solid 1px;">{{ model.wf_usage }} </td>
                  </tr>
                  <tr>
                    <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Discount</td>
                    <td style="border-top: black solid 1px;">{{ model.discount_price }} </td>
                  </tr>
                  <tr style="background-color: skyblue;">
                    <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Charges *</td>
                    <td style="border-top: black solid 1px;"> {{ model.total_price }} </td>
                  </tr>
                </table>
                <br>
                <p>
                  * Include VAT
                </p>
                <p>
                  ** When you log in to the console site, you can check detailed usage history and download PDF files of the invoice.
                </p>
              </div>
            </div>
            <div id="footer" style="height:60px;">
              <img style="float:right;" v-if="model.partner && model.partner.logo" :src="model.partner.logo" alt="partner logo" width="200">
            </div>
          </div>
          <!-- <b-row style="height:250px;">
            <b-col md="6">
              <b-form-group>
                <h4 for="ph_partner_name">User Summary</h4>
                <label class="ml-3" >Bill To Partner</label>
                <p v-if="model.partner" class="ml-3">
                  {{model.partner.username}}
                </p>
                <label class="ml-3" >Bill To Address</label>
                <p v-if="model.partner" class="ml-3">
                  {{model.group.address}}
                </p>
                <hr>
                <p class="text-left">
                  <label class="ml-3" >Description</label>
                  <p class="ml-3">
                    {{model.description}}
                  </p>
                </p>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group>
                <h4 for="ph_partner_name">Invoice Summary</h4>
                <label class="ml-3 w-100 pr-5" >Invoice Number : <span class="float-right">{{ model.invoice_id }}</span> </label>
                <label class="ml-3 w-100 pr-5" >Invoice Date : <span class="float-right">{{ model.created_at | sdate }}</span> </label>
                <hr>
                <label class="ml-3 w-100 pr-5" >Total Amount : <span class="float-right">{{ model.total_price + model.total_paid }}</span> </label>
              </b-form-group>
              <hr>
              <p class="text-center">
                <img class="text-center" width="200" :src="model.partner.logo || 'img/F1-uwss.png'" alt="Hello, F1security">
              </p>
            </b-col>
          </b-row>
          <hr>
          <b-row class="mb-3">
            <b-col md="12">
              <h3>
                Billing period: {{model.start_at }} ~ {{model.end_at }}
                <small class="float-right">* Include VAT</small>
              </h3>
            </b-col>
            <img v-if="model.is_paid" width="200" :src="'img/pay_clear.png'" alt="F1security" style="position:absolute; top: 500px; left: 40%; transform:rotate(-45deg); ">
          </b-row>
          <b-row>
            <b-col md="12">
              <table style="width: 100%; text-align: left; border-collapse: collapse; border-spacing: 0;">
                <tr style="background-color: gainsboro;">
                  <th style="padding: 5px;" colspan="3">Detail For Bill</th>
                </tr>
                <tr>
                  <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px; width:60%;">UWSS Service Type</td>
                  <td colspan="2" style="border-top: black solid 1px;">{{ model.service.service_name }} </td>
                </tr>
                <tr>
                  <td style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Quantity & Amount Used</td>
                  <td style="border-top: black solid 1px;"> {{model.service_unit | number}} </td>
                  <td style="border-top: black solid 1px;"> {{model.base_price | number}} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WEBCastle (Web Application Firewall)</td>
                  <td style="border-top: black solid 1px;">{{ model.wc_usage }} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WSFinder (Anti-WebShell)</td>
                  <td style="border-top: black solid 1px;">{{ model.wsf_usage }} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WMDS (Web Malware Scanner)</td>
                  <td style="border-top: black solid 1px;">{{ model.wmds_usage }} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px; padding-left: 50px;">WFDetector (Web Forgery Detection)</td>
                  <td style="border-top: black solid 1px;">{{ model.wf_usage }} </td>
                </tr>
                <tr>
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Discount</td>
                  <td style="border-top: black solid 1px;">{{ model.discount_price | number }} </td>
                </tr>
                <tr style="background-color: skyblue;">
                  <td colspan="2" style="padding: 5px 5px 5px 20px; border-top: black solid 1px;">Charges *</td>
                  <td style="border-top: black solid 1px;"> {{(model.is_paid ? model.paid_price : ((model.total_price || 0) + (model.paid_price || 0))  ) | number }} </td>
                </tr>
              </table>
            </b-col>
          </b-row> -->
          <hr>
          <!-- 부분 결제가 있을 경우 히스토리 내역 필요 -->
          <b-row>
            <b-col md="12">
              <label for=""><h4>Partial Payment History</h4></label>
            </b-col>
            <hr>
            <b-col md="12">
              <!-- TODO : 테이블로 예쁘게 해야 함 -->
              <ul class="list-group">
                <li class="list-group-item" v-for="(item, index) in payment_history" v-bind:key="index" v-bind:class="{ strong: item.hp > 300 }">
                  <small v-if="item && item.payer">
                    <!-- paypal -->
                    <!-- {{item}} -->
                    [Purchased Date:{{item.purchase_units[0].payments.captures[0].create_time | datetime}}]
                    [Company:{{item.payer.email_address}}]
                    [Action:{{item.purchase_units[0].description}}]
                    [Method:{{item.pg}}]
                    [Price:{{item.purchase_units[0].amount.value}}]
                    [Currenty:{{item.purchase_units[0].amount.currency_code}}]
                    [Country:{{item.payer.address.country_code}}]
                  </small>
                  <small v-else>
                    <!-- boot_pay or credit -->
                    [Purchased Date:{{item.purchased_at | datetime}}]
                    [Company:{{item.pg_name}}]
                    [Action:{{item.action}}]
                    [Method:{{item.pg}}]
                    [Price:{{item.price}}]
                    [Currenty:{{'KRW'}}]
                    [Country:{{'KR'}}]
                  </small>
                </li>
              </ul>
            </b-col>
          </b-row>
          <!-- <b-button v-if="!lock" size="sm" variant="success" @click="save"> Save </b-button>
          <b-button v-else size="sm" variant="warning" @click="edit">Edit </b-button> -->
          <!-- <b-button v-if="!lock" size="sm" variant="info" @click="cancel"> Cancel </b-button> -->
          <!-- <b-button size="sm" variant="danger" @click="confirm = true;" v-if="model.id && lock"> Remove </b-button> -->
          <hr v-if="is_show">
          <b-button v-if="is_show" :disabled="model.is_paid" class="float-left m-1" size="sm" variant="info" @click="is_pay = true; model.pay_price = model.total_price"> Manual Payment </b-button>
          <b-button v-if="is_show" size="sm" class="float-right m-1" variant="primary" @click="list"> List </b-button>
        </b-card>
      </b-col>
    </b-row>

    <router-view></router-view>
    <!-- modal area -->
    <!-- <b-modal title="Remove"  class="modal-danger" v-model="confirm" @ok="remove" ok-variant="danger">
      If this group have user, can't log in after removed
      <br>
      Check first, this  group's user
      <br>
      Would You Like to Remove the group?
    </b-modal> -->
    <!-- modal area -->
    <b-modal title="Manual Payment"  v-model="is_pay" @ok="pay" ok-variant="warning">
      <!-- <b-checkbox class="ml-3 mt-1" v-model="use_system_credit">Use System Credit (default using partner's credit)</b-checkbox>
      <hr> -->
      <span>
        <!-- Payment can be made with partner's credit or system's credit -->
        Payment by partner's credit
      </span>
      <hr>
      <b-form-input md=12 type="text" id="ph_name" v-model="model.pay_price" ></b-form-input>
    </b-modal>
  </div>
</template>

<script>

import { Api } from '@/service';
import codes from '@/codes';
import reg from '@/reg';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';
import { saveAs } from 'file-saver';
import * as htmlToImage from 'html-to-image';
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from 'html-to-image';
import moment from 'moment-timezone'

export default {
  components: {
    cSwitch,
    vSelect,
  },
  data : () => {
    return {
      use_system_credit : false,
      is_pay : false,
      exporting : false,
      is_show : true,
      so : {
        perPage: 15,
        currentPage: 1, totalRows: 0,
        sk: 'service.name', sv: '', skt: 'Service', opt : {}
      },
      add : false,
      reg,
      confirm : false,
      model : { service : { service_name : '' }, group : { }, partner : { logo : '' }, pay_price : 0 },
      lock : true,
      codes,
      // group with partner
      chainPartner : false,
      syncPartner : false,
      passPartner : false,
      // 일부 거래 기록
      payment_history : []
    }
  },
  computed: {},
  methods: {
    async pay() {
      console.log('is_partner_credit?', this.use_system_credit, this.model.pay_price)
      // 파트너 크레딧을 사용하여 빌링 결제

      let rs = await Api.Billing_Call('group', 'payment.credit', Object.assign({}, { id : this.model.id, amount : this.model.pay_price,  }));
      if(rs.error) {
        return this.$toastr.e('pay failed', rs.reason)
      } else {
        this.$toastr.s('Payment completed')
        this.model = Object.assign({}, this.model, rs.body)

        if(this.model.history) {
            this.payment_history = []
            this.model.history.forEach(r => {
              this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
            });
          }
        this.$emit('refresh')
      }
    },
    async share() {
      try {
        if(this.exporting) { return; }
        this.exporting = true
        this.is_show = false

        console.log("Generating shared image")
        this.$toastr.i("Generating shared image")

        let blob = await htmlToImage.toBlob(document.getElementById('_share'))
        saveAs(blob, `${this.model.group.groupname}_invoice_${this.model.apply_date}.png`);
        this.is_show = true
        this.exporting = false

        this.$toastr.s("Shared Image Creation Complete")
      } catch (e) { console.log(e); return this.$toastr.e("export image failed");  }
    },
    edit:function() { this.lock = false },
    cancel: function() {
      if(this.$route.params.id == "add") { this.list(); }
      this.lock = true
      this.$emit('refresh')
    },
    list: function() { this.$router.push({ name: 'InvoiceGroup' }); this.$emit('refresh'); },
    remove: function() {
      Api.Manager_Call('invoice.group', 'delete', { id : this.model.id })
        .then((rs) => {
          if(!rs.error) {
            this.$toastr.s('removed.', this.$route.name);
          } else {
            console.log("remove", 'failed', rs.reason, this.model.id)
            return this.$toastr.e('delete', "failed")
          }
          this.list();
        }).catch(e => (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list()));
    },
    getRowCount () { return this.so.totalRows || 0; },
    async partnerSave() {
      try {
        this.model.partner_id = this.model.partner.id;

        let rs = await Api.Manager_Call('invoice', 'update', Object.assign({}, this.model, { partner : {} }, this.region));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id);
        } else {
          this.$toastr.e('Save', "failed"); this.refresh();
        }
        this.syncPartner = false;
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); }
    },
    save: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }
        if(!(this.model.service || '').trim()) { return this.$toastr.e('Service is Require.'); }
        if(!(this.model.email || this.model.contact || '').trim()) { return this.$toastr.e('email or contact is Require.'); }
        if(!(this.model.address || '').trim()) { return this.$toastr.e('address is Require.'); }
        // if(!this.model.partner && !this.model.partner_id) { return this.$toastr.e('partner is Require.'); }

        let rs = await Api.Manager_Call('invoice.partner', this.model.id ? 'update' : 'insert', Object.assign({}, this.model));
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
          this.refresh(rs.body.id)
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
        this.lock = true;
        this.refresh()
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText); this.list()}
    },
    get: async function({ id, tag, invoice_id } = this.$route.params) {
      console.log('invoice.detail.vue', 'load item', id, invoice_id);
      if(id === 'add' || tag === 'invoice') { this.model.is_verified = true; this.add = (tag != 'invoice'); this.lock = false; return; }
      else {
        Api.Manager_Call('invoice','detail', { id : id, invoice_id : invoice_id })
          .then(rs => {
            if(rs.error) { return this.$toastr.e("load faild", this.$route.name); }
            this.model = Object.assign({}, this.model, rs.body)

            if(this.model.history) {
              this.payment_history = []
              this.model.history.forEach(r => {
                this.payment_history.push(typeof r == typeof 'string' ? JSON.parse(r) : r)
              });
            }

            // set days
            // this.model.start = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-01')
            // this.model.end = moment(this.model.apply_date, 'YYYYMM').format('YYYY-MM-'+moment(this.model.apply_date, 'YYYYMM').daysInMonth())

            // console.log(this.model)
          })
          .catch(e => {
            console.log(e)
            (this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText), this.list())
          });
      }
    },
    refresh(id) {
      this.$router.push({ name: 'InvoiceGroup', params : { id : id ? id : this.$route.params.id } }); this.$emit('refresh');
    }
  },
  watch: { '$route' (to, from) { console.log("from", from); this.get(to.params); } },
  created: function() { console.log('invoice.detail.vue', 'created'); },
  destroyed: function() { console.log('invoice.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('invoice.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
</script>
